export const filters = (
  geo,
  category,
  offerType,
  enviroment,
  popularity,
  rating,
  price,
  priceLevel,
  businessType,
  predicateName,
  name
) => [
  {
    id: 'geo',
    value: geo === undefined ? undefined : geo
  },
  {
    id: 'category',
    value: category === undefined ? undefined : category
  },
  {
    id: 'offerType',
    value: offerType === undefined ? undefined : offerType
  },
  {
    id: enviroment !== 'legacy' ? 'recent' : 'popularity',
    value: popularity === undefined ? undefined : popularity
  },
  {
    id: 'rating',
    value: rating === undefined ? undefined : rating
  },
  {
    id: enviroment !== 'legacy' ? 'discountSort' : 'price',
    value: price === undefined ? undefined : price
  },
  {
    id: 'price',
    value: priceLevel === undefined ? undefined : priceLevel
  },
  {
    id: 'businessType',
    value: businessType === undefined ? undefined : businessType
  },
  {
    id: 'businessName',
    value: predicateName === undefined ? undefined : predicateName
  },
  {
    id: 'name',
    value: name === undefined ? undefined : name
  }
]
